// Raw data type from backend
export type IRawViewMonitoringStatusInfo = {
  view_luid: string;
  has_should_monitor: true;
  should_monitor: boolean;  // Ignore should_monitor when has_should_monitor is false
  status: RawMonitoringStatus;
}

export enum ProcessedShouldMonitor {
  ShouldMonitor = 'ShouldMonitor',
  ShouldNotMonitor = 'ShouldNotMonitor',
  Unconfigured = 'Unconfigured',
}

export interface IProcessedViewMonitoringStatusInfo {
  viewLuid: string;
  shouldMonitor: ProcessedShouldMonitor;
  status: ProcessedMonitoringStatus;
}

export enum RawMonitoringStatus {
  CannotBeMonitored = 'CannotBeMonitored',
  Monitored = 'Monitored',
  NotMonitored = 'NotMonitored',
  Pending = 'Pending',
  MonitoredCannotStop = 'MonitoredCannotStop',
}

export enum ProcessedMonitoringStatus {
  CannotBeMonitored = 'CannotBeMonitored',
  Monitored = 'Monitored',
  NotMonitored = 'NotMonitored',
  Pending = 'Pending',
  MonitoredCannotStop = 'MonitoredCannotStop',
  Loading = 'Loading',
  Unknown = 'Unknown',
}
